import RegisterTrade from './RegisterTrade';

export default RegisterTrade;
